import React, { useEffect, useLayoutEffect } from 'react';
import Animated from 'react-native-reanimated';
import { format, parse } from 'date-fns';
import SectionHeader from 'design-system/SectionHeader';
import { SettingsSection } from 'design-system/SettingsSection';
import { SettingsItemNavigate } from 'design-system/SettingsItem';
import { IconBoldCalendar, IconProfile } from 'design-system/icons';
import { AppView, CardView, rem, SCROLL_INDICATOR_INSETS, Spacer } from 'design-system';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import useColors from 'hooks/useColors';
import { DOB_DISPLAY_FORMAT } from 'hooks/useDateTimePickerDOB';
import { useAppSelector } from 'store/hooks';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { selectTradingAccount } from '../reducers/selectors';
import FormattedAddress from '../components/FormattedAddress';
import { isWeb } from '../../../constants';
const JISAChildDetails = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const colors = useColors();
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    const tradingAccount = useAppSelector(selectTradingAccount);
    const childDetails = tradingAccount?.account.accountType === 'JISA' ? tradingAccount.account.child : undefined;
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    useEffect(() => {
        if (!childDetails) {
            navigation.popToTop();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!childDetails) {
        return <AppView />;
    }
    const { firstName, surname, dateOfBirth, address } = childDetails;
    return (<AppView type="secondary" withFrame={false}>
        <Animated.ScrollView scrollEventThrottle={16} onScroll={scrollHandler} contentContainerStyle={contentContainerStyle} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
          <SectionHeader horizontalMargins largeVerticalMargins>
            Personal details
          </SectionHeader>
          <SettingsSection noMarginTop>
            <SettingsItemNavigate disabled title={firstName} description="First name" icon={<IconProfile gradientKey="skyBlue"/>}/>
            <SettingsItemNavigate disabled title={surname} description="Last name" icon={<IconProfile gradientKey="yellow"/>}/>
            <SettingsItemNavigate disabled description="Date of birth" icon={<IconBoldCalendar gradientKey="peach"/>} title={format(parse(dateOfBirth, 'yyyy-MM-dd', new Date()), DOB_DISPLAY_FORMAT)}/>
          </SettingsSection>
          <SectionHeader horizontalMargins largeVerticalMargins>
            Address
          </SectionHeader>
          <CardView noMarginTop noMarginBottom withPadding>
            <FormattedAddress {...address} uk/>
            <Spacer h={rem(4)}/>
          </CardView>
        </Animated.ScrollView>
      </AppView>);
}, ({ colors }) => ({
    title: 'Child’s details',
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default JISAChildDetails;
